import { LuRadar, LuSend, LuSparkles, LuTrendingUp } from 'react-icons/lu';
import Skeleton from '../skeleton/Skeleton';
import { StyledCampaignCard, StyledCampaigns } from './Campaigns.styles';

/** The hero stat cards' icons, in display order (the skeleton draws one card per key). */
export const STAT_ICONS = {
  active: LuSparkles,
  signals: LuRadar,
  touches: LuSend,
  meetings: LuTrendingUp,
};

const CampaignCardSkeleton = ({ index }) => (
  <StyledCampaignCard
    $skeleton
    $ring="var(--hd-border)"
    $tint="var(--hd-muted)"
    $dot="var(--hd-border)"
    style={{ animationDelay: `${index * 60}ms` }}
    aria-hidden="true">
    <div className="card-head">
      <div className="card-identity">
        <Skeleton width={56} height={56} radius="22px" resp />
        <div className="identity-text">
          <Skeleton width={72} height={18} radius="6px" resp />
          <Skeleton width={160} height={14} radius="6px" margin="6px 0 0" resp />
        </div>
      </div>
    </div>
    <div className="card-metrics">
      {[0, 1, 2, 3].map(key => (
        <div key={key} className="metric">
          <Skeleton width={48} height={20} radius="6px" resp />
          <Skeleton width={72} height={12} radius="6px" margin="6px 0 0" resp />
        </div>
      ))}
    </div>
    <div className="card-actions">
      <Skeleton width="100%" height={40} radius="18px" />
    </div>
  </StyledCampaignCard>
);

/** The whole page's shape, shown until the campaigns and their totals have both arrived. */
const CampaignsSkeleton = () => (
  <StyledCampaigns aria-busy="true">
    <main className="campaigns-main">
      <section className="campaigns-hero">
        <div className="hero-row">
          <div>
            <Skeleton width={200} height={34} radius="8px" resp />
            <Skeleton width={520} height={14} radius="6px" margin="14px 0 0" resp />
            <Skeleton width={380} height={14} radius="6px" margin="8px 0 0" resp />
          </div>
          <Skeleton width={168} height={44} radius="18px" resp />
        </div>
        <div className="stats-grid">
          {Object.keys(STAT_ICONS).map(key => (
            <div key={key} className="stat-card">
              <div className="stat-top">
                <div>
                  <Skeleton width={110} height={12} radius="6px" resp />
                  <Skeleton width={56} height={24} radius="8px" margin="10px 0 0" resp />
                </div>
                <Skeleton width={40} height={40} radius="14px" resp />
              </div>
              <Skeleton width={88} height={12} radius="6px" resp />
            </div>
          ))}
        </div>
      </section>
      <section>
        <div className="section-head">
          <Skeleton width={90} height={14} radius="6px" resp />
        </div>
        <div className="campaigns-grid">
          {Array.from({ length: 4 }).map((_, index) => (
            <CampaignCardSkeleton key={`campaign-skeleton-${index}`} index={index} />
          ))}
        </div>
      </section>
    </main>
  </StyledCampaigns>
);

export default CampaignsSkeleton;
